import { Injectable, LOCALE_ID, Injector } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface CuesNaviNode {
  title: string;
  url: string;
  target?: string;
  type?: string;
  locale?: string[];
  lastUpdateDate: string;
}

@Injectable({
  providedIn: 'root',
})
export class CuesTocService {
  valueSubject = new BehaviorSubject<any>('');

  public nodes: CuesNaviNode[] = [
    {
      title: $localize`Dealer's Manual & Exploded View`,
      url: 'manual/search?doctype=DM,UM,EV&series=CUES',
      target: '_self',
      type: 'link',
      lastUpdateDate: '',
    },
    {
      title: $localize`Technical Documents`,
      url: '/pdfs/cues/technical-assets/CUES_Technical_Documents_LC_SHB_COMP.pdf',
      target: '_brank',
      type: 'pdf',
      lastUpdateDate: '',
    },
    {
      title: $localize`SHIMANO Product Website`,
      url: 'https://bike.shimano.com/products/series/cues.html',
      target: '_brank',
      type: 'link',
      lastUpdateDate: '',
    },
  ];

  constructor(private injector: Injector) {}

  getToc(): void {
    const locale = this.injector.get(LOCALE_ID);

    this.nodes = this.nodes.filter((node: any) => {
      if (node.locale !== undefined) {
        if (node.locale.indexOf(locale) !== -1) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    });

    this.valueSubject.next(this.nodes);
  }
}
